export enum Endpoint {
    AreaList = "/api/addresses/areas/",
    InstructorList = "/api/lectures/instructors/",
    TopicList = "/api/lectures/topics/",
    LectureList = "/api/lectures/lectures/",
    Login = "api/users/login/",
    Register = "api/users/register/",
    LectureCreate = "api/lectures/create/",
    LectureDelete = "api/lectures/delete/",
    Users="api/users/"
}